var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5999 15.625H16.611M15.0599 12.25H17.6999C18.725 12.25 19.2376 12.25 19.6419 12.4213C20.1809 12.6496 20.6092 13.0876 20.8325 13.639C20.9999 14.0524 20.9999 14.5766 20.9999 15.625C20.9999 16.6734 20.9999 17.1976 20.8325 17.611C20.6092 18.1624 20.1809 18.6004 19.6419 18.8287C19.2376 19 18.725 19 17.6999 19H4.49995C3.47488 19 2.96234 19 2.55805 18.8287C2.01899 18.6004 1.5907 18.1624 1.36742 17.611C1.19995 17.1976 1.19995 16.6734 1.19995 15.625C1.19995 14.5766 1.19995 14.0524 1.36742 13.639C1.5907 13.0876 2.01899 12.6496 2.55805 12.4213C2.96234 12.25 3.47488 12.25 4.49995 12.25H7.13995M11.1 13.375V1M11.1 1L14.4 4.375M11.1 1L7.79995 4.375",
    stroke: "#FD6202",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.33aa196345e6a7544e0ba47c5a3976c4.svg";
export { ForwardRef as ReactComponent };